import axios from 'axios';
import { Auth } from 'aws-amplify';
import router from '@/router';

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
});

// 请求拦截器
service.interceptors.request.use(
    async config => {
        const isToken = (config.headers || {}).isToken === false;
        if (!isToken) {
            try {
                const session = await Auth.currentSession();
                const token = session.getIdToken().getJwtToken();
                config.headers['Authorization'] = 'Bearer ' + token;
            } catch (e) {
                console.warn('Token 获取失败，尝试未登录或已过期', e);
                // 可以选择直接跳转或在响应拦截器中处理
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        return response.data;
    },
    async error => {
        if (error.response) {
            const status = error.response.status;
            switch (status) {
                case 401:
                    console.warn('未授权，跳转登录页');
                    await Auth.signOut();
                    router.push('/auth');
                    break;
                case 403:
                    console.error('拒绝访问');
                    break;
                case 404:
                    console.error('接口不存在');
                    break;
                case 500:
                    console.error('服务器错误');
                    break;
                default:
                    console.error(`接口错误 ${status}`);
            }
        } else if (error.request) {
            console.error('网络错误');
        } else {
            console.error('请求异常:', error.message);
        }
        return Promise.reject(error);
    }
);

export default service;
